import React from 'react';

export default function BondsOverview({ onExplore }) {
  return (
    <section className="overview-bonds bg-white rounded-xl shadow-md p-6 border-t-4 border-indigo-500 hover:shadow-lg transition-shadow" aria-labelledby="overview-bonds-title">
      <div className="text-indigo-600 mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5h16v5a2 2 0 000 4v5H4v-5a2 2 0 000-4V5zm8 3v2m0 4v2" />
        </svg>
      </div>
      <h4 id="overview-bonds-title" className="text-3xl font-bold text-gray-900 mb-1">Bonds</h4>
      <div className="text-sm font-semibold text-gray-700 mb-2">Buy ADBYTES</div>
      <p className="text-xs text-gray-600 leading-relaxed">Pay in USDC or ETH. Choose immediate delivery or discounted vesting.</p>
      <a className="overview-bonds-link" href="#bonds" onClick={onExplore}>Explore ADBYTES bonds</a>
    </section>
  );
}
